// ------------------------------------
// Check version Internet Explorer
// https://stackoverflow.com/questions/17907445/how-to-detect-ie11
// ------------------------------------
export const checkInternetExplorerVersion = function() {
  let ua = null
  let re = null
  let rv = -1
  if (navigator.appName == 'Microsoft Internet Explorer') {
    ua = navigator.userAgent
    re = new RegExp(/MSIE ([0-9]{1,}[.0-9]{0,})/)
    if (re.exec(ua) != null)
      rv = parseFloat(RegExp.$1)
  } else if (navigator.appName == 'Netscape') {
    ua = navigator.userAgent
    re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})')
    if (re.exec(ua) != null)
      rv = parseFloat(RegExp.$1)
  }
  return rv
}




// WEBPACK FOOTER //
// ./src/modules/checkInternetExplorerVersion.js